import { gql } from '@apollo/client'
import React from 'react'

import { checklistsClient } from '../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../components/helpers/LazyAction'
import StatePresenter from '../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useChecklistsState = () => React.useContext(Context) || {}
export const useChecklists = () => useChecklistsState()?.checklists || []

const QUERY = gql`
  query Checklists($page: Int, $limit: Int, $search: String, $filter: ChecklistFilter) {
    checklists(page: $page, limit: $limit, search: $search, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
    }
  }
`

const ChecklistsLoader = ({ children, search, filter, perPage: limit, uncontrolledChildren }) => {
  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      limit: limit || 24,
      search,
      sort: { field: 'NAME', type: 'ASC' },
      filter
    },
    client: checklistsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default ChecklistsLoader
